import React from 'react';
import styled from '@emotion/styled'
import { Grid } from 'style';
import { Media, Spacer200 } from '..';
import ExternalVideoMediaComponent from '../media/media.externalvideo.component';

const SmallImageVideoComponent = ({
    image,
    video,
    mediaRight,
    mediaCenter,
    loop,
    backgroundColor,
    backgroundImage,
    textColor,
    imageBackgroundColor,
    showFullscreenControl,
    showMuteControl
}) => (
        <SmallImageVideoWrapper backgroundImage={backgroundImage && backgroundImage.url} id="SmallImageVideoComponent">
            <Grid.Wrapper
                backgroundColor={!backgroundImage && backgroundColor && backgroundColor.hex}
                textColor={textColor && textColor.hex}
            >
                {backgroundImage && backgroundImage.url && <Spacer200 />}
                <Grid.Container>
                    <Grid.Row>
                        <ImageContainer mediaRight={mediaRight} mediaCenter={mediaCenter}>
                            {video && <Media video={video} loop={loop}
                                showFullscreenControl={showFullscreenControl}
                                showMuteControl={showMuteControl} />}
                            {image && <Media
                                backgroundColor={
                                    imageBackgroundColor && imageBackgroundColor.hex
                                }
                                image={image}
                                loop={loop}
                                showFullscreenControl={showFullscreenControl}
                                showMuteControl={showMuteControl}
                            />}
                        </ImageContainer>
                    </Grid.Row>
                </Grid.Container>
            </Grid.Wrapper>
            {backgroundImage && backgroundImage.url && <Spacer200 />}
        </SmallImageVideoWrapper>
    );


const SmallImageVideoWrapper = styled.div`
  background-image: ${props => props.backgroundImage ? `url(${props.backgroundImage});` : ''};
  background-size: cover;
  background-position: center;
`;
const ImageContainer = styled.div`
    max-width: ${100 / 18 * 10}%;
    margin: ${props => (props.mediaCenter ? '0 auto' : props.mediaRight ? '0 0 0 auto' : '0 auto 0 0')};
    img {
        max-width: 100%;
    }

    width: 100%;
`;

export default SmallImageVideoComponent;
